import HeroCarousel from './HeroCarousel';
const els = document.querySelectorAll('.hero-carousel');

for (let el of els) {
  HeroCarousel(el);
}
